(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55],{

/***/ 7244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var components_OldDesign_header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6627);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8369);
/* harmony import */ var styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6494);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var models_conent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3290);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9417);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6529);
/* harmony import */ var components_OldDesign_subscribe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1640);
/* harmony import */ var react_modal_video__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1239);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5582);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_OldDesign_OldLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4990);
/* harmony import */ var _components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5314);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5893);

















var responsive = {
  desktop: {
    breakpoint: {
      max: 5000,
      min: 1280
    },
    items: 5
  },
  tablet: {
    breakpoint: {
      max: 1279,
      min: 640
    },
    items: 3
  },
  mobile: {
    breakpoint: {
      max: 640,
      min: 0
    },
    items: 1
  }
};
var categoriesResponsive = {
  tablet: {
    breakpoint: {
      max: 5000,
      min: 1024
    },
    items: 3
  },
  mobile: {
    breakpoint: {
      max: 1023,
      min: 0
    },
    items: 1
  }
};

var Blogs = function Blogs(_ref) {
  var _content$filter, _content$filter2, _content$filter3, _content$filter3$sort, _content$filter4, _content$filter4$sort, _content$filter5, _content$filter6, _content$filter7, _content$filter8, _content$filter9, _content$find, _content$find$image, _content$filter10, _content$filter11, _categories$find, _categories$find2, _categories$find2$vid, _categories$find3, _categories$find4, _categories$find4$blo;

  var contents = _ref.contents,
      categories = _ref.categories;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      content = _useState[0],
      setContent = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      tag = _useState2[0],
      setTag = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      search = _useState3[0],
      setSearch = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var _useLocale = (0,_components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_10__/* .useLocale */ .b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      hoverTag = _useState5[0],
      setHoverTag = _useState5[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _localStorage$getItem;

    setContent(contents);
    setLang((_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th');
    setTag(contents === null || contents === void 0 ? void 0 : contents.map(function (element) {
      return element.tags;
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []).map(function (el) {
      return el.tag;
    }).filter(function (item, i, ar) {
      return ar.indexOf(item) === i;
    })); // console.log(categories);
    // console.log(content);
    // console.log(content?.filter((item: any) => item?.recommend).sort((a, b) => a.recommend.sequence - b.recommend.sequence));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {}, [tag]);

  function calculateRead(item) {
    var _moment$fromNow;

    moment__WEBPACK_IMPORTED_MODULE_8___default().locale(lang);
    return item ? lang === 'th' ? 'อ่านเมื่อ ' + moment__WEBPACK_IMPORTED_MODULE_8___default()(item).fromNow() : ((_moment$fromNow = moment__WEBPACK_IMPORTED_MODULE_8___default()(item).fromNow()) === null || _moment$fromNow === void 0 ? void 0 : _moment$fromNow.toUpperCase()) + ' READ' : null;
  }

  function truncateString(str) {
    if ((str === null || str === void 0 ? void 0 : str.length) > 85) {
      return str.substring(0, 85) + '...';
    } else {
      return str;
    }
  }

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      var _e$target;

      window.location.href = '/categories?tag=' + ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "px-12 xl:px-24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_OldDesign_header__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        content: {
          title: 'CODIUM Blogs - อัปเดตข่าวสารและความรู้ด้านดิจิทัล',
          content: 'ติดตามบทความและข้อมูลเชิงลึกจาก CODIUM รวมถึงเทคโนโลยีใหม่ล่าสุด e-Signature, e-Tax, Digital Transformation และโซลูชันดิจิทัลสำหรับธุรกิจ',
          image: null
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "h-full w-full relative pt-40 pb-12 md:pt-24",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-20",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: "grid grid-cols-3 align-self-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "bg-dark-blue border-dark-blue border-2 text-center text-white py-4 md:py-1 cursor-pointer rounded-l-xl",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: "text-4xl md:text-xl lg:text-2xl",
                children: "Blogs"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: "/issues",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "border-dark-blue border-t-2 border-b-2 text-center py-4 md:py-1 cursor-pointer ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  className: "text-4xl md:text-xl lg:text-2xl underline",
                  children: "Issues"
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: "/categories",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "border-dark-blue border-2 text-center py-4 md:py-1 cursor-pointer rounded-r-xl",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  className: "text-4xl md:text-xl lg:text-2xl underline",
                  children: "Categories"
                })
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("input", {
              type: "text",
              className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().outlineNone), " ").concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().search), " xl:m-auto bg-white border-b w-full lg:mx-8 border-dark-blue px-2 text-dark-blue h-20 lg:h-12 text-2xl md:text-xl lg:text-2xl"),
              placeholder: "Search Tag",
              value: search,
              onKeyDown: function onKeyDown(e) {
                return handleKeyDown(e);
              },
              onChange: function onChange(e) {
                setSearch(e.target.value);
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
              icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faSearch */ .wn1,
              className: "absolute right-3 text-2xl fa-2x top-5 lg:top-2 text-dark-blue"
            })]
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: "grid grid-rows-1 lg:grid-cols-2",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: '/blogs/' + (content === null || content === void 0 ? void 0 : (_content$filter = content.filter(function (item) {
            return item === null || item === void 0 ? void 0 : item.recommend;
          })) === null || _content$filter === void 0 ? void 0 : _content$filter.sort(function (a, b) {
            return a.recommend.sequence - b.recommend.sequence;
          })[0].id) + '-' + (content === null || content === void 0 ? void 0 : (_content$filter2 = content.filter(function (item) {
            return item.recommend;
          })) === null || _content$filter2 === void 0 ? void 0 : _content$filter2.sort(function (a, b) {
            return a.recommend.sequence - b.recommend.sequence;
          })[0].url),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: "m-4 shadow-2xl bg-white cursor-pointer relative xl:h-auto bg-no-repeat bg-cover bg-center rounded-2xl flex flex-col-reverse h-40",
            style: {
              backgroundImage: "url(".concat(models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1).concat(content === null || content === void 0 ? void 0 : (_content$filter3 = content.filter(function (item) {
                return item.recommend;
              })) === null || _content$filter3 === void 0 ? void 0 : (_content$filter3$sort = _content$filter3.sort(function (a, b) {
                return a.recommend.sequence - b.recommend.sequence;
              })[0].image) === null || _content$filter3$sort === void 0 ? void 0 : _content$filter3$sort.url, ")")
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: "px-6 py-10 relative text-white trans-bg",
              children: [content === null || content === void 0 ? void 0 : (_content$filter4 = content.filter(function (item) {
                return item.recommend;
              })) === null || _content$filter4 === void 0 ? void 0 : (_content$filter4$sort = _content$filter4.sort(function (a, b) {
                return a.recommend.sequence - b.recommend.sequence;
              })[0].categories) === null || _content$filter4$sort === void 0 ? void 0 : _content$filter4$sort.map(function (item, i) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: '/categories/' + item.id + '-' + item.name,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: "inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-dark-blue bg-white font-light text-2xl md:text-lg lg:text-base xl:text-xs border-gray-300 cursor-pointer mr-2 mb-1",
                      children: item.name
                    })
                  }) : ''
                }, i);
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h1", {
                className: "mb-8 mt-3 lg:mt-1 text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug",
                children: truncateString(content === null || content === void 0 ? void 0 : (_content$filter5 = content.filter(function (item) {
                  return item.recommend;
                })) === null || _content$filter5 === void 0 ? void 0 : _content$filter5.sort(function (a, b) {
                  return a.recommend.sequence - b.recommend.sequence;
                })[0].title)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                children: [moment__WEBPACK_IMPORTED_MODULE_8___default()(content === null || content === void 0 ? void 0 : (_content$filter6 = content.filter(function (item) {
                  return item.recommend;
                })) === null || _content$filter6 === void 0 ? void 0 : _content$filter6.sort(function (a, b) {
                  return a.recommend.sequence - b.recommend.sequence;
                })[0].created_at).format('MMM DD, YYYY').toUpperCase(), content !== null && content !== void 0 && (_content$filter7 = content.filter(function (item) {
                  return item.recommend;
                })) !== null && _content$filter7 !== void 0 && _content$filter7.sort(function (a, b) {
                  return a.recommend.sequence - b.recommend.sequence;
                })[0].timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  className: "mx-3",
                  children: "\u2022"
                }) : '', calculateRead(content === null || content === void 0 ? void 0 : (_content$filter8 = content.filter(function (item) {
                  return item.recommend;
                })) === null || _content$filter8 === void 0 ? void 0 : _content$filter8.sort(function (a, b) {
                  return a.recommend.sequence - b.recommend.sequence;
                })[0].timeStamp)]
              })]
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "grid grid-rows-1 m-4",
          children: content === null || content === void 0 ? void 0 : (_content$filter9 = content.filter(function (item) {
            return item.recommend;
          })) === null || _content$filter9 === void 0 ? void 0 : _content$filter9.sort(function (a, b) {
            return a.recommend.sequence - b.recommend.sequence;
          }).map(function (item, index) {
            var _item$imageMobile, _item$image;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
              children: index > 0 && index < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "".concat(index < 3 ? 'mb-10 lg:mb-6' : '', " md:flex"),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "cursor-pointer",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                      src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$imageMobile = item.imageMobile) === null || _item$imageMobile === void 0 ? void 0 : _item$imageMobile.url),
                      loading: "lazy",
                      alt: item.title,
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().minW15), " xl:hidden h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover")
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                      src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url),
                      loading: "lazy",
                      alt: item.title,
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().minW15), " hidden xl:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover")
                    })]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: '/blogs/' + item.id + '-' + item.url,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: "text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer",
                      children: truncateString(item.title)
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                    children: [moment__WEBPACK_IMPORTED_MODULE_8___default()(item.created_at).format('MMM DD, YYYY').toUpperCase(), item.timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      className: "mx-3",
                      children: "\u2022"
                    }) : '', calculateRead(item.timeStamp), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      children: item.categories.map(function (tag, i) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                          href: '/categories/' + tag.id + '-' + tag.name,
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                            children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                              className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-xs cursor-pointer mr-2",
                              children: tag.name
                            }) : ''
                          })
                        }, i);
                      })
                    })]
                  })]
                })]
              }) : ''
            }, index);
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "col-span-1 lg:col-span-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/issues",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "border-dark-blue text-right py-4 md:py-1 cursor-pointer ",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: "text-4xl md:text-3xl lg:text-2xl",
                children: "See More >>"
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: "grid md:block",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "px-3 w-full lg:w-1/2 inline-block mb-12 lg:mb-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: "h-96 bg-no-repeat bg-contain bg-center rounded-2xl",
            style: {
              backgroundImage: "url(".concat(models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1).concat(content === null || content === void 0 ? void 0 : (_content$find = content.find(function (item) {
                return item.name === 'trend';
              })) === null || _content$find === void 0 ? void 0 : (_content$find$image = _content$find.image) === null || _content$find$image === void 0 ? void 0 : _content$find$image.url, ")")
            }
          })
        }), content === null || content === void 0 ? void 0 : (_content$filter10 = content.filter(function (item) {
          return item.name === 'article';
        })) === null || _content$filter10 === void 0 ? void 0 : _content$filter10.sort(function (a, b) {
          return a.view < b.view ? 1 : -1;
        }).map(function (item, i) {
          var _item$imageMobile2, _item$image2;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
            children: i < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: "w-full ".concat(i === 0 ? 'md:w-1/2' : 'md:w-1/2 lg:w-1/3', " mb-10 inline-block px-3"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "xl:hidden",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().trendingHeight), " bg-no-repeat bg-center bg-cover rounded-2xl w-5/6 ").concat(i === 0 ? 'md:w-2/3' : 'md:w-3/4', " ml-auto relative shadow-2xl cursor-pointer"),
                    style: {
                      backgroundImage: "url(".concat(models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1).concat((_item$imageMobile2 = item.imageMobile) === null || _item$imageMobile2 === void 0 ? void 0 : _item$imageMobile2.url, ")")
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().trending), " absolute"),
                      children: i + 1
                    })
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "hidden xl:block",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().trendingHeight), " bg-no-repeat bg-center bg-cover rounded-2xl w-5/6 ").concat(i === 0 ? 'md:w-2/3' : 'md:w-3/4', " ml-auto relative shadow-2xl cursor-pointer"),
                    style: {
                      backgroundImage: "url(".concat(models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1).concat((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url, ")")
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().trending), " absolute"),
                      children: i + 1
                    })
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "w-5/6 md:w-3/4 ml-auto mt-3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                    className: "text-3xl lg:text-lg cursor-pointer ".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lineClamp), " pt-3"),
                    children: item.title
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "justify-between flex text-3xl md:text-xl mt-2",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "/issues",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      className: "cursor-pointer",
                      children: "Issue"
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                    className: "mw-70percent",
                    children: item.categories.map(function (tag, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: '/categories/' + tag.id + '-' + tag.name,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                          children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                            className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2",
                            children: tag.name
                          }) : ''
                        })
                      }, i);
                    })
                  })]
                })]
              })]
            }) : ''
          }, i);
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "text-5xl font-bold mb-12",
        children: "Recent Stories"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2",
        children: content === null || content === void 0 ? void 0 : (_content$filter11 = content.filter(function (item) {
          return item.name === 'article';
        })) === null || _content$filter11 === void 0 ? void 0 : _content$filter11.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        }).map(function (item, index) {
          var _item$imageMobile3, _item$image3;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
            children: index < 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: "".concat(index < 3 ? 'mb-10 lg:mb-6' : '', " md:flex"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: '/blogs/' + item.id + '-' + item.url,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$imageMobile3 = item.imageMobile) === null || _item$imageMobile3 === void 0 ? void 0 : _item$imageMobile3.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().minW15), " xl:hidden h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.url),
                    loading: "lazy",
                    alt: item.title,
                    className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().minW15), " hidden xl:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer")
                  })]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: '/blogs/' + item.id + '-' + item.url,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer",
                    children: truncateString(item.title)
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2",
                  children: [moment__WEBPACK_IMPORTED_MODULE_8___default()(item.created_at).format('MMM DD, YYYY').toUpperCase(), item.timeStamp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                    className: "mx-3",
                    children: "\u2022"
                  }) : '', calculateRead(item.timeStamp), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    children: item.categories.map(function (tag, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: '/categories/' + tag.id + '-' + tag.name,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                          children: i < 3 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                            className: "mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-xs cursor-pointer mr-2",
                            children: tag.name
                          }, i) : ''
                        })
                      }, i);
                    })
                  })]
                })]
              })]
            }) : ''
          }, index);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2 gap-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: "relative order-2 lg:order-1",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_modal_video__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            channel: "youtube",
            autoplay: true,
            isOpen: isOpen,
            videoId: categories === null || categories === void 0 ? void 0 : (_categories$find = categories.find(function (obj) {
              return obj.name === 'Video';
            })) === null || _categories$find === void 0 ? void 0 : _categories$find.link,
            onClose: function onClose() {
              return setOpen(false);
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
            src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + (categories === null || categories === void 0 ? void 0 : (_categories$find2 = categories.find(function (obj) {
              return obj.name === 'Video';
            })) === null || _categories$find2 === void 0 ? void 0 : (_categories$find2$vid = _categories$find2.videoCover) === null || _categories$find2$vid === void 0 ? void 0 : _categories$find2$vid.url),
            loading: "lazy",
            alt: categories === null || categories === void 0 ? void 0 : (_categories$find3 = categories.find(function (obj) {
              return obj.name === 'Video';
            })) === null || _categories$find3 === void 0 ? void 0 : _categories$find3.name,
            className: "w-full rounded-2xl cursor-pointer",
            onClick: function onClick() {
              return setOpen(true);
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faPlayCircle */ .aQp,
            onClick: function onClick() {
              return setOpen(true);
            },
            className: "text-white fa-7x lg:fa-5x absolute absolute-center"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: "place-self-center order-1 lg:order-2",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
            src: "".concat(models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1, "/uploads/Group_13715_2x_2cf33a651e.png"),
            loading: "lazy",
            alt: "",
            className: "w-full h-96 lg:h-60 xl:h-40 rounded-2xl object-cover"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: '/categories/' + (categories === null || categories === void 0 ? void 0 : categories.find(function (obj) {
              return obj.name === 'Video';
            }).id) + '-Video',
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "text-right text-5xl lg:text-2xl mt-5 mx-3 cursor-pointer",
              children: "See More"
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_5__["default"], {
        className: "blog",
        responsive: responsive,
        children: categories === null || categories === void 0 ? void 0 : (_categories$find4 = categories.find(function (obj) {
          return obj.name === 'Video';
        })) === null || _categories$find4 === void 0 ? void 0 : (_categories$find4$blo = _categories$find4.blogs) === null || _categories$find4$blo === void 0 ? void 0 : _categories$find4$blo.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        }).map(function (item, i) {
          var _item$imageMobile4, _item$image4;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: {
              pathname: '/categories/' + (categories === null || categories === void 0 ? void 0 : categories.find(function (obj) {
                return obj.name === 'Video';
              }).id) + '-Video',
              query: {
                videoId: item.id
              }
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "m-4 shadow-lg bg-white cursor-pointer relative xl:h-auto rounded-2xl",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                  src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$imageMobile4 = item.imageMobile) === null || _item$imageMobile4 === void 0 ? void 0 : _item$imageMobile4.url),
                  loading: "lazy",
                  alt: item.title,
                  className: "xl:hidden w-full h-96 md:h-60 xl:h-40 rounded-2xl object-cover"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                  src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$image4 = item.image) === null || _item$image4 === void 0 ? void 0 : _item$image4.url),
                  loading: "lazy",
                  alt: item.title,
                  className: "hidden xl:block w-full h-96 md:h-60 xl:h-40 rounded-2xl object-cover"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "m-5 text-center cursor-pointer text-4xl sm:text-3xl lg:text-2xl xl:text-lg 2xl:text-xl",
                children: item.title
              })]
            })
          }, i);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "text-5xl font-bold mb-12 text-center",
      children: "Let's Explore these Categories"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_5__["default"], {
      className: "explore",
      responsive: categoriesResponsive,
      children: categories === null || categories === void 0 ? void 0 : categories.sort(function (a, b) {
        return a.id < b.id ? 1 : -1;
      }).map(function (item, i) {
        var _item$image5, _item$name, _item$name2;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: '/categories/' + (item === null || item === void 0 ? void 0 : item.id) + '-' + (item === null || item === void 0 ? void 0 : item.name),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: "relative text-center",
            onMouseOver: function onMouseOver() {
              return setHoverTag(i);
            },
            onMouseLeave: function onMouseLeave() {
              return setHoverTag(null);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
              className: "w-full h-80 object-cover cursor-pointer",
              alt: "hero",
              src: models_conent__WEBPACK_IMPORTED_MODULE_14__/* .strapi */ .s1 + ((_item$image5 = item.image) === null || _item$image5 === void 0 ? void 0 : _item$image5.url)
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "xl:hidden absolute absolute-center text-white text-9xl md:text-6xl cursor-pointer underline wrap-anywhere break-words w-11/12",
              children: (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toUpperCase()
            }), hoverTag === i ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "".concat((styles_Content_module_scss__WEBPACK_IMPORTED_MODULE_12___default().fadeIn), " hidden xl:block absolute absolute-center text-white text-9xl md:text-6xl cursor-pointer underline wrap-anywhere break-words w-11/12"),
              children: (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.toUpperCase()
            }) : '']
          })
        }, i);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "px-12 xl:px-24",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("hr", {
        className: "border-dark-blue my-12",
        style: {
          'borderWidth': '1px'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_OldDesign_subscribe__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})]
  });
};

Blogs.getLayout = function (page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_OldDesign_OldLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Blogs);

/***/ }),

/***/ 4026:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(7244);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,885,735,859,373,239,769,60,608,597,774,888,179], function() { return __webpack_exec__(4026); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);